<template>
  <img v-if="asset" :src="asset" :alt="brand" :height="height" />
  <v-icon v-else :size="Number(height)" color="secondary" :title="title">mdi-credit-card-outline</v-icon>
</template>
<script>
import { cardBrandAsset } from '@/utils/payments/card-brand-asset'

export default {
  name: 'card-brand',
  props: {
    brand: {
      type: String,
      default: ''
    },
    height: {
      type: [Number, String],
      default: 24
    }
  },
  computed: {
    asset () {
      return cardBrandAsset(this.brand)
    },
    title () {
      // Webpay stores no brand at all, so an empty value is the common case
      // and deserves wording that does not read as an error.
      return this.brand || 'Marca no informada'
    }
  }
}
</script>
